import Svg from 'components/utilities/svg'

const UpDownIcon = ({ ...props }) => (
  <Svg viewBox="0 -960 960 960" {...props}>
    <title>Up Down Icon</title>
    <path fill="none" d="M0 0h24v24H0z" />
    <path d="M320-440v-287L217-624l-57-56 200-200 200 200-57 56-103-103v287h-80ZM600-80 400-280l57-56 103 103v-287h80v287l103-103 57 56L600-80Z"></path>
  </Svg>
)

UpDownIcon.displayName = 'UpDown'

export default UpDownIcon
